import React from 'react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';
import { MapPin, Clock, Users, Shield, Heart } from 'lucide-react';

const CTASection = ({ 
  backgroundColor = "bg-gradient-to-br from-purple-600 to-pink-500"
}) => {
  return (
    <section className={`py-16 ${backgroundColor} text-white`}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-bold mb-6">
              Come Visit Our Happy Place!
            </h2>
            <div className="space-y-4 mb-8">
              <div className="flex items-start space-x-3 bg-white/20 p-4 rounded-xl">
                <MapPin className="h-5 w-5 mt-1 flex-shrink-0 text-yellow-300" />
                <div>
                  <p className="font-bold text-lg">10681 248 St, Maple Ridge, BC</p>
                  <p className="text-purple-100">Easy parking for families</p>
                </div>
              </div>
              <div className="flex items-start space-x-3 bg-white/20 p-4 rounded-xl">
                <Clock className="h-5 w-5 mt-1 flex-shrink-0 text-green-300" />
                <div>
                  <p className="font-bold text-lg">Monday - Friday: 7:00 AM - 5:00 PM</p>
                  <p className="text-purple-100">Closed weekends and holidays</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                asChild 
                size="lg" 
                className="bg-yellow-400 hover:bg-yellow-500 text-purple-800 font-bold px-8 py-4 rounded-full shadow-lg hover:shadow-xl transition-all"
              >
                <Link to="/contact">Book Your Visit</Link>
              </Button>
              <Button 
                asChild 
                size="lg" 
                className="bg-white/20 hover:bg-white/30 text-white border-2 border-white hover:border-yellow-300 font-bold px-8 py-4 rounded-full transition-all"
              >
                <Link to="/enroll">Enroll Now</Link>
              </Button>
            </div>
          </div>

          <div className="relative">
            <div className="bg-white/20 backdrop-blur-sm p-8 rounded-2xl border-2 border-white/30">
              <h3 className="text-2xl font-bold mb-6 text-center">
                Why Choose Maple Kids?
              </h3>
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center">
                    <Users className="h-4 w-4 text-purple-800" />
                  </div>
                  <span className="font-medium">Small groups, big love</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-green-400 rounded-full flex items-center justify-center">
                    <Shield className="h-4 w-4 text-purple-800" />
                  </div>
                  <span className="font-medium">Licensed & insured</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-pink-400 rounded-full flex items-center justify-center">
                    <Heart className="h-4 w-4 text-purple-800" />
                  </div>
                  <span className="font-medium">Every child is welcome</span>
                </div>
              </div>
              
              <div className="mt-6 text-center bg-white/20 p-4 rounded-xl">
                <p className="text-sm font-medium">Ready to join our family?</p>
                <p className="text-xs text-purple-100 mt-1">Tours available by appointment</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;